import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { CX } from '../../constants'
import { me, emailConfirmed } from '../../initial_state'
import Button from '../button'
import Heading from '../heading'
import BackButton from '../back_button'
import Pills from '../pills'
import Search from '../search'
import Text from '../text'

class SidebarLayout extends React.PureComponent {

  render() {
    const {
      actions,
      tabs,
      title,
      showBackBtn,
      children,
      search,
      button,
      theme,
      widthClass,
      slimLayout,
    } = this.props

    const innerContainerClasses = CX({
      d: 1,
      posFixed: 1,
      bgPrimary: theme !== 'black' && !slimLayout,
      bgNavigation: theme === 'black' && !slimLayout,
      borderRight1PX: !slimLayout,
      borderColorSecondary: !slimLayout,
      calcH53PX: emailConfirmed || !me,
      calcH106PX: !emailConfirmed && !!me,
      bottom0: 1,
    })

    const wClass = !!widthClass ? widthClass : _s.w340PX

    return (
      <header role='banner' className={[_s.d, _s.z3, _s.aiStart].join(' ')}>
        <div className={[_s.d, wClass].join(' ')}>
          <div className={innerContainerClasses}>
            <div className={[_s.d, _s.h100PC, _s.aiStart, wClass, _s.py15, _s.noScrollbar, _s.overflowYScroll].join(' ')}>
              <div className={[_s.d, _s.w100PC, _s.saveAreaInsetPT].join(' ')}>
                {
                  !!title &&
                  <div className={[_s.d, _s.flexRow, _s.px15, _s.pb5, _s.aiStart, _s.flexWrap].join(' ')}>
                    {
                      showBackBtn &&
                      <BackButton className={[_s.h30PX, _s.w30PX, _s.circle,  _s.bgSubtle_onHover, _s.mt2].join(' ')} icon='arrow-left' />
                    }
                    <div className={_s.mrAuto}>
                      <span className={[_s.d, _s.text, _s.fs27PX, _s.fw700, _s.cPrimary].join(' ')}>{title}</span>
                    </div>
                    {
                      !!actions &&
                      <div className={[_s.d, _s.bgTransparent, _s.flexRow, _s.aiCenter, _s.jcCenter].join(' ')}>
                        {
                          actions.map((action, i) => (
                            <Button
                              isNarrow
                              backgroundColor='tertiary'
                              color='primary'
                              onClick={action.onClick ? () => action.onClick() : undefined}
                              to={action.to}
                              href={action.href}
                              key={`action-btn-${i}`}
                              className={i === 0 ? _s.px5 : [_s.ml5, _s.px5].join(' ')}
                              icon={action.icon}
                              iconClassName={[_s.cSecondary, _s.px5, _s.py5].join(' ')}
                              iconSize='15px'
                            >
                              {
                                !!action.title &&
                                <Text color='inherit' weight='medium' className={[_s.py5, _s.px10].join(' ')}>{action.title}</Text>
                              }
                            </Button>
                          ))
                        }
                      </div>
                    }
                  </div>
                }
                {
                  !!search &&
                  <div className={[_s.d, _s.px15, _s.pb5].join(' ')}>
                    <Search className={[_s.circle, _s.bgTertiary].join(' ')} placeholder={search.placeholder} to={search.to} />
                  </div>
                }
                {
                  (!!tabs && Array.isArray(tabs) && tabs.length > 0) &&
                  <div className={[_s.d, _s.px15, _s.pb10, _s.pt10].join(' ')}>
                    <Pills pills={tabs} />
                  </div>
                }

                {
                  !!button &&
                  <div className={[_s.d, _s.px15, _s.pb10].join(' ')}>
                    <Button
                      radiusSmall
                      to={button.to}
                      icon={button.icon}
                      onClick={button.onClick}
                      className={[_s.aiCenter, _s.jcCenter].join(' ')}
                    >
                      <Text color='inherit' weight='medium' size='medium' className={_s.ml10}>{button.title}</Text>
                    </Button>  
                  </div>
                }

                {
                  (!!tabs && Array.isArray(tabs) && tabs.length > 0) &&
                  <div className={[_s.d, _s.w100PC, _s.borderBottom1PX, _s.borderColorSecondary].join(' ')} />
                }
              </div>
              <nav aria-label='Primary' role='navigation' className={[_s.d, _s.w100PC, _s.px10, _s.mb15].join(' ')}>
                {children}
              </nav>

            </div>
          </div>
        </div>
      </header>
    )
  }

}

const mapStateToProps = (state) => ({
  theme: state.getIn(['settings', 'displayOptions', 'theme']),
})

SidebarLayout.propTypes = {
  actions: PropTypes.array,
  tabs: PropTypes.array,
  title: PropTypes.string,
  showBackBtn: PropTypes.bool,
}

export default connect(mapStateToProps)(SidebarLayout)
